<template>
  <el-dialog :close-on-click-modal="false" title="产品类" :visible.sync="isShow" width="800px">
    <el-form ref="form" :model="form" inline label-width="80px">
      <el-form-item label="产品类">
        <el-input v-model="form.categoryName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="init()">查询</el-button>
        <el-button type="primary" @click="$refs.AddEdit.show('top', false)">添加分类</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="table" :data="tableData" style="width: 100%" row-key="categoryId" border lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      :row-class-name="rowClassName">
      <el-table-column prop="categoryId" label="ID"></el-table-column>
      <el-table-column prop="categoryName" label="产品类"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span class="color-blue" @click="$refs.AddEdit.show(scope, true)"> 编辑 </span>
          <span class="color-blue" v-if="scope.row.level === 1" @click="$refs.AddEdit.show(scope, false)"> 添加下级 </span>
          <span @click="deleteDialog = true, deleteItem = scope.row, deleteCategoryId = scope.row.categoryId" v-permission="'pos:admin:category:delete'" class="color-blue">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <AddEdit @fatherMethod="init" ref='AddEdit' :tagsId="tagsId"></AddEdit>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">取 消</el-button>
      <el-button type="primary" @click="isShow = false">确 定</el-button>
    </span>
    <el-dialog :close-on-click-modal="false" width="30%" title="确认" :visible.sync="deleteDialog" append-to-body>
      <span>确认删除该产品类</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteConfirm()">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import AddEdit from './AddEdit.vue'
import { posCategoryList, posCategoryQueryAllSubs, categoryDeleteAdmin } from '@/api/pms'
export default {
  components: {
    AddEdit
  },
  data () {
    return {
      deleteItem: '',
      deleteCategoryId: '',
      tagsId: '',
      isShow: false,
      deleteDialog: false,
      form: {},
      tableData: [],
      treeNodeObj: {}
    }
  },
  methods: {
    show (id) {
      console.log(id)
      this.tagsId = id
      this.init()
      this.isShow = true
    },
    init () {
      this.tableData = []
      posCategoryList({
        tagsId: this.tagsId,
        categoryName: this.form.categoryName
      })
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.reduce((list, item) => {
              item.hasChildren = !item.final
              list.push(item)
              return list
            }, [])
          }
        })
    },
    load (tree, treeNode, resolve) {
      this.treeNodeObj[tree.categoryId] = {
        tree,
        resolve
      }
      posCategoryQueryAllSubs(tree.categoryId)
        .then(res => {
          if (res.data.success) {
            let children = res.data.data.subCategoryList.reduce((list, item) => {
              item.hasChildren = !item.final
              list.push(item)
              return list
            }, [])
            resolve(children)
          }
        })
    },
    deleteConfirm () {
      categoryDeleteAdmin(this.deleteCategoryId).then(res => {
        if (res.data.success) {
          console.log(this.deleteItem)
          this.$message.success('删除成功')
          if (this.treeNodeObj[this.deleteItem.parentId]) {
            this.$set(this.$refs.table.store.states.lazyTreeNodeMap, this.deleteItem.parentId, [])
            this.load(this.treeNodeObj[this.deleteItem.parentId].tree, '', this.treeNodeObj[this.deleteItem.parentId].resolve)
          } else {
            this.init()
          }
          this.deleteDialog = false
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    }
  }
}
</script>
<style></style>
